import React, { useState } from 'react';
import { Dialog, DialogContent } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

import { translate } from '../../../i18n/I18nProvider';
import CustomDialogTitle from '../../../partials/customDialogTitle/CustomDialogTitle';
import CustomSwitch from '../../../partials/CustomSwitch';
import DraggableDialog from '../../../partials/DraggableDialog';
import UserDetailsTable from './UserDetailsTable';
import styles from '../styles/userDetailDialog';

const UserDetailDialog = ({ data, open, onClose, classes }) => {
  const { telephonyUser, user } = data ?? {};
  const [expandAll, setExpandAll] = useState(false);
  const [expandSignal, setExpandSignal] = useState(null);

  const onExpandAllChange = event => {
    const checked = event.target.checked;
    setExpandAll(checked);
    setExpandSignal({ open: checked, id: Date.now() });
  };

  return (
    <Dialog
      maxWidth={false}
      PaperComponent={DraggableDialog}
      classes={{ paper: classes.dialogPaper }}
      open={open}
      onClose={onClose}
    >
      <CustomDialogTitle onCloseClick={onClose}>
        <div className={classes.title}>{translate('USER_DETAILS')}</div>
      </CustomDialogTitle>
      <DialogContent className={classes.dialogContent}>
        <div className={classes.expandAllRow}>
          <div className={classes.expandAllLabel}>
            {translate('EXPAND_ALL')}
          </div>
          <CustomSwitch checked={expandAll} handleChange={onExpandAllChange} />
        </div>
        <div className={classes.section}>
          <div className={classes.sectionTitle}>
            {translate('NUMBER.TELEPHONY_USER')}
          </div>
          <UserDetailsTable data={telephonyUser} expandSignal={expandSignal} />
        </div>
        <div className={classes.section}>
          <div className={classes.sectionTitle}>{translate('MENU.USER')}</div>
          <UserDetailsTable data={user} expandSignal={expandSignal} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default withStyles(styles)(UserDetailDialog);
